<template>
<div>
	<el-dialog title="节假日IP配置"
	:visible.sync="openDialog"
	width="1000px"
	:before-close="handleDialogCloseAnoths"
	>
	<div style="height: 500px;overflow: auto;" v-loading="loading">
		<el-table
			:header-cell-style="{
				'text-align': 'center',
				'border-bottom': '2px solid #EBEEF5',
				background: '#FAFAFA',
			}"
			:cell-style="{ 'text-align': 'center', overflow: 'visible' }"
			:data="tableData"
			border
			style="overflow: visible;"
		>
			<el-table-column label="操作" width="200px">
				<template slot-scope="scope">
					<span
						class="s"
						style="color:#7B61FF;cursor: pointer;"
						@click="itemDel(scope.$index)"
						>删除</span
					>
					<span @click="itemAdd(scope.$index)" style="cursor: pointer;color: #7B61FF;margin-left: 20px;" v-if="scope.$index == tableData.length -1">添加</span>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="生效时间段" width="400">
				<template slot-scope="scope">
					<div class="my_select_time">
						<el-date-picker
                  prefix-icon="no_icon"
                  v-model="scope.row.startEnableTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 150px; font-size: 12px"
                  class="time1"
                  @change="activityTimeChange(scope.$index)"
                  :clearable="false"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="scope.row.endEnableTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 150px; font-size: 12px"
                  class="time2"
                  @change="activityTimeChange(scope.$index)"
                  :clearable="false"
                >
                </el-date-picker>
						<!-- <i class="el-icon-circle-close date_icon1" @click="clearTime(scope.$index)"></i>
						<img src="@/assets/images/select_date.svg" alt="" class="date_icon2" /> -->
					</div>
				</template>
			</el-table-column>
			<el-table-column label="文字颜色">
				<template slot-scope="scope">
					<!-- <el-color-picker v-model="scope.row.textColor"></el-color-picker> -->
					<input type="color" v-model="scope.row.textColor" />
				</template>
			</el-table-column>
			<el-table-column label="等级图片/文件" width="410">
				<template slot-scope="scope">
					<div style="display: flex;align-items: center;">
					<el-upload
						ref="upload"
						action="#"
						class="avatar-uploader"
						list-type="picture-card"
						:http-request="httpRequest"
						:on-change="(file, fileList) => {handleChange(file, fileList,scope.$index)}"
						:on-remove="(file, fileList) => {handleRemove(file, fileList,scope.$index)}"
						v-loading="scope.row.isEditfile"
						:class="scope.row.ishavefile?'hide_box':''"
						:file-list="fileList"
					>
						<!-- :before-upload="beforeUpload" -->
						<img v-if="scope.row.previewUrl != ''" :src="scope.row.previewUrl" class="avatar">
						<img v-else-if="scope.row.fileUrl" :src="scope.row.fileUrl" class="avatar">
						<i class="el-icon-plus"></i>
					</el-upload>

					<div style="color: red; font-size: 14px;">建议尺寸：712px*720px，图片大小不能超过300kb，视频大小不能超过1.5M，类型：JPG、PNG、GIF、MP4</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="视频封面" width="410">
				<template slot-scope="scope">
					<div style="display: flex;align-items: center;">
					<el-upload
						ref="upload2"
						action="#"
						class="avatar-uploader"
						list-type="picture-card"
						:http-request="httpRequest"
						:on-change="(file, fileList) => {handleChange2(file, fileList,scope.$index)}"
						:on-remove="(file, fileList) => {handleRemove2(file, fileList,scope.$index)}"
						:before-upload="beforeUpload2"
						v-loading="scope.row.isEditVideo"
						:class="scope.row.ishaveVideo?'hide_box':''"
						:file-list="fileList2"
					>

						<img v-if="scope.row.videoUrl" :src="scope.row.videoUrl" class="avatar">
						<i class="el-icon-plus"></i>
					</el-upload>

					<div style="color: red; font-size: 14px;">建议尺寸：712px*720px，图片大小不能超过300kb，类型：JPG、PNG</div>
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
	<span slot="footer" class="dialog-footer">
			<el-button @click="cancelAdd" class="cancel_Btn">取 消</el-button>
			<el-button type="primary" class="sure_Btn" @click="saveData()">确 定</el-button>
	</span>
	</el-dialog>
</div>
</template>
	
<script>
import {uploadpic,getIpConfigInfo,saveIpConfig,delIpConfig } from "@/api/brandCustom/brandMemberCenter";
export default {
name: '' ,
components: {},
props:{
openDialog:{
	type:Boolean,
},
editData:{
	type:Object
}
},
data() {
return {
	loading:false,
	tableData:[
		{
			startEnableTime:'',
			endEnableTime:'',
			textColor:'#000000',
			fileUrl:'',
			videoUrl:'',//视频封面链接
			isEditVideo:false,
			isEditfile:false,
		}
	],
	fileList:[],
	fileList2:[],
}
},
computed: {},
created() {

},
mounted() {
	this.getIpConfigInfo()
},
methods: {
	//获取
	getIpConfigInfo(){
		this.loading = true
		let params = {
			levelId:this.editData.id,
			type:1
		}
		getIpConfigInfo(params).then((res) => {
			this.loading=false
			if (res.code == 1) {
				if(res.data.length > 0) {
					this.tableData=res.data
					this.tableData = res.data.map((item) => {
						return { ...item, 
							isEditVideo:false,
							isEditfile:false,
							ishaveVideo:false,
							ishavefile:false,
							levelId:this.editData.id,
							type:1
						};
					});
				}else{
					this.tableData=[{
						startEnableTime:'',
						endEnableTime:'',
						textColor:'#000000',
						fileUrl:'',
						videoUrl:'',
						ishaveVideo:false,
						isEditVideo:false,
						ishavefile:false,
						isEditfile:false,
						levelId:this.editData.id,
						type:1,
						category:1
					}]
				}
			}
		});
	},
	saveData(){

		
		//生日权益说明图
		let isFlay = false;
		this.tableData.forEach((item) => {
			
			if(!item.startEnableTime || !item.endEnableTime){
				this.$message.warning("生效时间段不可为空！");
				isFlay = true
				return;
			}

			if(!item.textColor ){
				this.$message.warning("文字颜色不可为空！");
				isFlay = true
				return;
			}

			if(!item.fileUrl ){
				this.$message.warning("等级图片/文件不可为空！");
				isFlay = true
				return;
			}

			if(item.fileUrl.includes('.mp4') || item.fileUrl.includes('.MP4') ){
				item.fileType  = 1
			}else{
				item.fileType  = 0
			}



			if(!item.videoUrl && item.fileType==1){
				this.$message.warning("视频封面不可为空！");
				isFlay = true
				return;
			}


		});
		if (isFlay) {
			return 
		}

		let params = {
			configs:this.tableData,
			levelId:this.editData.id,
			type:1
		}

		saveIpConfig(params).then((res) => {
			if (res.code == 1) {
				this.$message.success("操作成功");
				this.$emit('saveData')
			}else{
				this.$message.error(res.message);
			}
		});
	},
	//上传文件
	handleChange(file, fileList,index) {
	const isLt3M = file.size < 1024 * 1024 * 1.5;
	if (!isLt3M) {
		this.$message.error("文件大小不符合要求，请重新上传");
		this.tableData[index].fileUrl = "";
		this.tableData[index].ishavefile = false;
		this.fileList = []
		this.$refs.upload.uploadFiles = [];
		this.$refs.upload.clearFiles();
	} else {
			if(!this.tableData[index].isEditfile){
				console.log("fileList",fileList)
				let formdata = new FormData();
				formdata.append("file", file.raw);
				this.tableData[index].isEditfile= true;
				if(this.tableData[index].fileUrl){
					this.tableData[index].fileUrl=''
					this.tableData[index].ishavefile = false;
				}
				uploadpic(formdata,1).then((res) => {
						this.tableData[index].isEditfile= false;
						if(res.code == 1){
							// 获取图片真实url
							this.tableData[index].fileUrl = res.data.fileUrl;
							this.tableData[index].ishavefile = true;
							if(res.data.previewUrl){
								file.url = res.data.previewUrl;
								this.tableData[index].previewUrl = res.data.previewUrl;
							}else{
								this.tableData[index].previewUrl = ''
							}
						}else{
							this.tableData[index].previewUrl = ''
							this.tableData[index].fileUrl = "";
							this.tableData[index].ishavefile = false;
							this.fileList = []
							this.$refs.upload.uploadFiles = [];
							this.$refs.upload.clearFiles();
							this.$message.error(res.message);
						}
				});
			}
		}
	},
	handleRemove(file, fileList,index) {
		this.tableData[index].fileUrl = "";
		file.url = '';
		fileList = []
		this.tableData[index].previewUrl = ''
		this.tableData[index].ishavefile = false;
	},
	beforeUpload(file) {
	let fileType
	if (this.limitType) {
		const typeArry = [".jpg", ".png", ".JPG", ".PNG"];
		const type = file.name.substring(file.name.lastIndexOf("."));
		const isImage = typeArry.indexOf(type) > -1;
		if (!isImage) {
			fileType = false;
			this.$message({
				message: "图片格式不符合要求，请重新上传！",
				type: "warning",
			});
		}
	} else {
		fileType = true;
	}
	return fileType;
	},
	//上传视频图片
	handleChange2(file, fileList,index) {
	const isLt3M = file.size < 1024 * 300;
	if (!isLt3M) {
		this.$message.error("文件大小不符合要求，请重新上传");
		this.tableData[index].videoUrl = '';
		this.tableData[index].ishaveVideo = false;
		this.fileList2 = []
		this.$refs.upload2.uploadFiles = [];
		this.$refs.upload2.clearFiles();
	} else {
			if(!this.tableData[index].isEditVideo){
				console.log("fileList",fileList)
				let formdata = new FormData();
				formdata.append("file", file.raw);
				this.tableData[index].isEditVideo= true;
				if(this.tableData[index].videoUrl){
					this.tableData[index].videoUrl=''
					this.tableData[index].ishaveVideo = false;
				}
				uploadpic(formdata,2).then((res) => {
						this.tableData[index].isEditVideo= false;
						if(res.code == 1){
							// 获取图片真实url
							this.tableData[index].videoUrl = res.data.fileUrl;
							this.tableData[index].ishaveVideo = true;
						}else{
							this.$message.error(res.message);
							this.tableData[index].videoUrl = '';
							this.tableData[index].ishaveVideo = false;
							this.fileList2 = []
							this.$refs.upload2.uploadFiles = [];
							this.$refs.upload2.clearFiles();
						}
				});
			}
		}
	},
	handleRemove2(file, fileList,index) {
		this.tableData[index].videoUrl = '';
		this.tableData[index].ishaveVideo = false;
	}, 
	beforeUpload2(file) {
	let fileType
	if (this.limitType) {
		const typeArry = [".jpg", ".png", ".JPG", ".PNG"];
		const type = file.name.substring(file.name.lastIndexOf("."));
		const isImage = typeArry.indexOf(type) > -1;
		if (!isImage) {
			fileType = false;
			this.$message({
				message: "图片格式不符合要求，请重新上传！",
				type: "warning",
			});
		}
	} else {
		fileType = true;
	}
	return fileType;
	},
	httpRequest() {},

	//活动时间驱动
	activityTimeChange(index) {
		let nowTime = new Date().getTime();
		let start = new Date(this.tableData[index].startEnableTime).valueOf();
		let end = new Date(this.tableData[index].endEnableTime).valueOf();
		console.log("index",index)
		if(index > 0){
			console.log("index",index)
			let beforeStart = new Date(this.tableData[index-1].startEnableTime).valueOf();
			let beforeEnd = new Date(this.tableData[index-1].endEnableTime).valueOf();
			console.log("start",start , beforeStart,  beforeEnd)
			console.log("index",start >= beforeStart&&start <= beforeEnd)
			if ( (start >= beforeStart && start <= beforeEnd) && start) {
				this.$message.warning("配置时间段含重合部分，请调整");
				this.tableData[index].startEnableTime = ''
				return;
			}
			if ( (end >= beforeStart && end <= beforeEnd) && end) {
				this.$message.warning("配置时间段含重合部分，请调整");
				this.tableData[index].endEnableTime = ''
				return;
			}

		}

		if (end < start && start && end) {
			this.$message.warning("结束时间不能小于开始时间");
			this.tableData[index].endEnableTime = ''
			return;
		}
	},

	//删除
	itemDel(index) {
	// if (this.tableData.length == 1) {
	// 	this.$message.warning("默认分类，不可删除");
	// 	return;
	// }
	this.tableData.splice(index, 1);
	},
	//增加
	itemAdd(){
	this.tableData.push({
		startEnableTime:'',
		endEnableTime:'',
		textColor:'#000000',
		fileUrl:'',
		videoUrl:'',
		ishaveVideo:false,
		isEditVideo:false,
		ishavefile:false,
		isEditfile:false,
		levelId:this.editData.id,
		type:1,
		category:1
	});
	},
	// 取消添加
	cancelAdd() {
		this.$emit('cancel')
	},
	handleDialogCloseAnoths() {
		this.$emit('cancel')
	}
}
}
</script>
<style lang='scss' scoped>
	.avatar-uploader .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
	}
	.avatar-uploader .el-upload:hover {
		border-color: #7b61ff;
	}
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 146px;
		height: 146px;
		line-height: 146px;
		text-align: center;
	}
	.avatar {
		width: 146px;
		height: 146px;
		display: block;
	}
	/deep/.hide_box .el-upload--picture-card{
			display: none;
	}
	</style>